import React, { useState } from 'react';
import { FaHome, FaEdit, FaPlus, FaEye, FaCog, FaUsers, FaFileAlt, FaChartBar, FaEnvelope, FaPhone, FaMapMarkerAlt, FaGlobe, FaFacebook, FaTwitter, FaLinkedin, FaInstagram, FaYoutube, FaWhatsapp, FaStar, FaAward, FaUsers as FaUsers2, FaBuilding, FaHeart, FaChartLine, FaUserTie, FaCheckCircle, FaShieldAlt, FaHandshake, FaLightbulb, FaBullseye, FaFileAlt as FaFileAlt2, FaEye as FaEye2, FaCog as FaCog2, FaWrench, FaTools, FaHammer, FaTruck, FaHardHat, FaIndustry, FaWarehouse, FaRoad, FaCity, FaUniversity, FaHospital, FaSchool, FaStore, FaHotel, FaShoppingCart, FaCreditCard, FaMoneyBillWave, FaChartBar as FaChartBar2, FaChartPie, FaChartArea, FaCalculator, FaClipboardList, FaCalendarAlt, FaClock, FaBell, FaSearch, FaFilter, FaSort, FaDownload, FaUpload, FaPrint, FaShare, FaBookmark, FaThumbsUp, FaThumbsDown, FaComment, FaReply, FaPlay, FaForward, FaBackward, FaPause, FaStop, FaVolumeUp, FaVolumeMute, FaVolumeDown, FaMicrophone, FaHeadphones, FaCamera, FaVideo, FaMusic, FaGamepad, FaDice, FaPuzzlePiece, FaChess, FaTrophy, FaMedal, FaCertificate, FaGraduationCap, FaBook, FaNewspaper, FaBlog, FaRss, FaPodcast, FaSpotify, FaApple, FaGoogle, FaMicrosoft, FaAmazon, FaDiscord, FaTelegram, FaReddit, FaGithub, FaStackOverflow, FaDev, FaMedium, FaBehance, FaDribbble, FaFigma, FaSketch, FaWordpress, FaShopify, FaMagento, FaOpencart, FaJoomla, FaDrupal, FaLaravel, FaReact, FaAngular, FaVuejs, FaNodeJs, FaPython, FaJava, FaPhp, FaDatabase, FaServer, FaCloud, FaLock, FaUnlock, FaKey, FaUserSecret, FaUserShield, FaUserCheck, FaUserTimes, FaUserPlus, FaUserMinus, FaUserEdit, FaUserCog, FaUserGraduate, FaUserNurse, FaUserMd, FaUserInjured, FaUserAstronaut, FaUserNinja, FaUserAlt, FaUserCircle, FaUserFriends, FaUserClock, FaUserTag, FaUserLock, FaUserSlash } from 'react-icons/fa';

interface AdminSidebarProps {
  language: 'ar' | 'en';
  currentPage?: string;
  onSectionAdd?: (sectionType: string) => void;
}

const AdminSidebar: React.FC<AdminSidebarProps> = ({ 
  language, 
  currentPage = 'dashboard',
  onSectionAdd 
}) => {
  const [expandedSections, setExpandedSections] = useState<string[]>([]);

  const isRTL = language === 'ar';

  // مكتبة السكاشن المتاحة
  const availableSections = [
    // سكاشن أساسية
    {
      category: 'basic',
      label: isRTL ? 'سكاشن أساسية' : 'Basic Sections',
      sections: [
        { type: 'HeroSection', label: isRTL ? 'قسم البطل' : 'Hero Section', icon: FaStar },
        { type: 'AboutPreview', label: isRTL ? 'معاينة من نحن' : 'About Preview', icon: FaEye },
        { type: 'ServicesSection', label: isRTL ? 'قسم الخدمات' : 'Services Section', icon: FaCog },
        { type: 'ProjectsSection', label: isRTL ? 'قسم المشاريع' : 'Projects Section', icon: FaBuilding },
        { type: 'ContactCallout', label: isRTL ? 'دعوة للتواصل' : 'Contact Callout', icon: FaPhone },
        { type: 'Footer', label: isRTL ? 'التذييل' : 'Footer', icon: FaFileAlt }
      ]
    },
    // سكاشن المحتوى
    {
      category: 'content',
      label: isRTL ? 'سكاشن المحتوى' : 'Content Sections',
      sections: [
        { type: 'VisionMissionSection', label: isRTL ? 'الرؤية والرسالة' : 'Vision & Mission', icon: FaBullseye },
        { type: 'WhyChooseUs', label: isRTL ? 'لماذا تختارنا' : 'Why Choose Us', icon: FaCheckCircle },
        { type: 'TestimonialsSection', label: isRTL ? 'آراء العملاء' : 'Testimonials', icon: FaUsers },
        { type: 'ImpactSection', label: isRTL ? 'قسم التأثير' : 'Impact Section', icon: FaChartBar },
        { type: 'NewsSection', label: isRTL ? 'قسم الأخبار' : 'News Section', icon: FaNewspaper },
        { type: 'MapSection', label: isRTL ? 'قسم الخريطة' : 'Map Section', icon: FaMapMarkerAlt }
      ]
    },
    // سكاشن الأعمال
    {
      category: 'business',
      label: isRTL ? 'سكاشن الأعمال' : 'Business Sections',
      sections: [
        { type: 'BusinessScopeSection', label: isRTL ? 'نطاق الأعمال' : 'Business Scope', icon: FaIndustry },
        { type: 'AboutHeroSection', label: isRTL ? 'هيرو من نحن' : 'About Hero', icon: FaUserTie },
        { type: 'AboutCompanyOverviewSection', label: isRTL ? 'نظرة عامة على الشركة' : 'Company Overview', icon: FaBuilding },
        { type: 'AboutQualitySafetySection', label: isRTL ? 'الجودة والسلامة' : 'Quality & Safety', icon: FaShieldAlt },
        { type: 'AboutProjectManagementSection', label: isRTL ? 'إدارة المشاريع' : 'Project Management', icon: FaChartLine },
        { type: 'AboutVisionMissionGoalsSection', label: isRTL ? 'الرؤية والرسالة والأهداف' : 'Vision Mission Goals', icon: FaBullseye },
        { type: 'AboutCoreValuesSection', label: isRTL ? 'القيم الأساسية' : 'Core Values', icon: FaHeart },
        { type: 'AboutWhyUsSection', label: isRTL ? 'لماذا نحن' : 'Why Us', icon: FaAward },
        { type: 'AboutTestimonialsSection', label: isRTL ? 'آراء العملاء' : 'Testimonials', icon: FaUsers },
        { type: 'AboutCTASection', label: isRTL ? 'دعوة للعمل' : 'Call to Action', icon: FaPhone }
      ]
    },
    // سكاشن الخدمات
    {
      category: 'services',
      label: isRTL ? 'سكاشن الخدمات' : 'Services Sections',
      sections: [
        { type: 'ServicesGridSection', label: isRTL ? 'شبكة الخدمات' : 'Services Grid', icon: FaCog },
        { type: 'ServicesCTASection', label: isRTL ? 'دعوة للعمل للخدمات' : 'Services CTA', icon: FaPhone }
      ]
    },
    // سكاشن المشاريع
    {
      category: 'projects',
      label: isRTL ? 'سكاشن المشاريع' : 'Projects Sections',
      sections: [
        { type: 'ProjectsHeroSection', label: isRTL ? 'هيرو المشاريع' : 'Projects Hero', icon: FaStar },
        { type: 'ProjectsGridSection', label: isRTL ? 'شبكة المشاريع' : 'Projects Grid', icon: FaBuilding }
      ]
    },
    // سكاشن التواصل
    {
      category: 'contact',
      label: isRTL ? 'سكاشن التواصل' : 'Contact Sections',
      sections: [
        { type: 'ContactHeroSection', label: isRTL ? 'هيرو التواصل' : 'Contact Hero', icon: FaStar },
        { type: 'ContactInfoSection', label: isRTL ? 'معلومات التواصل' : 'Contact Info', icon: FaEnvelope }
      ]
    }
  ];

  const toggleSection = (category: string) => {
    setExpandedSections(prev => 
      prev.includes(category) 
        ? prev.filter(cat => cat !== category)
        : [...prev, category]
    );
  };

  const handleAddSection = (sectionType: string) => {
    if (onSectionAdd) {
      onSectionAdd(sectionType);
    }
  };

  const menuItems = [
    { 
      id: 'dashboard', 
      label: isRTL ? 'لوحة التحكم' : 'Dashboard', 
      icon: FaHome, 
      path: '/admin/dashboard' 
    },
    { 
      id: 'pages', 
      label: isRTL ? 'الصفحات' : 'Pages', 
      icon: FaFileAlt, 
      path: '/admin/pages' 
    },
    { 
      id: 'sections', 
      label: isRTL ? 'السكاشن' : 'Sections', 
      icon: FaEdit, 
      path: '/admin/sections' 
    },
    { 
      id: 'users', 
      label: isRTL ? 'المستخدمين' : 'Users', 
      icon: FaUsers, 
      path: '/admin/users' 
    },
    { 
      id: 'analytics', 
      label: isRTL ? 'التحليلات' : 'Analytics', 
      icon: FaChartBar, 
      path: '/admin/analytics' 
    },
    { 
      id: 'settings', 
      label: isRTL ? 'الإعدادات' : 'Settings', 
      icon: FaCog, 
      path: '/admin/settings' 
    }
  ];

  return (
    <div className={`bg-gray-900 text-white w-64 min-h-screen ${isRTL ? 'font-cairo' : 'font-montserrat'}`} dir={isRTL ? 'rtl' : 'ltr'}>
      {/* Logo */}
      <div className="p-6 border-b border-gray-700">
        <h1 className="text-xl font-bold text-center">
          {isRTL ? 'لوحة التحكم' : 'Admin Panel'}
        </h1>
      </div>

      {/* Navigation Menu */}
      <nav className="p-4">
        <ul className="space-y-2">
          {menuItems.map((item) => {
            const IconComponent = item.icon;
            return (
              <li key={item.id}>
                <a
                  href={item.path}
                  className={`flex items-center px-4 py-2 rounded-lg transition-colors ${
                    currentPage === item.id
                      ? 'bg-blue-600 text-white'
                      : 'text-gray-300 hover:bg-gray-700 hover:text-white'
                  }`}
                >
                  <IconComponent className="w-5 h-5 ml-3" />
                  {item.label}
                </a>
              </li>
            );
          })}
        </ul>
      </nav>

      {/* Sections Library */}
      <div className="p-4 border-t border-gray-700">
        <h3 className="text-lg font-semibold mb-4 text-gray-200">
          {isRTL ? 'مكتبة السكاشن' : 'Sections Library'}
        </h3>
        
        <div className="space-y-2">
          {availableSections.map((category) => (
            <div key={category.category} className="border border-gray-700 rounded-lg">
              <button
                onClick={() => toggleSection(category.category)}
                className="w-full flex items-center justify-between px-4 py-3 text-left hover:bg-gray-800 transition-colors"
              >
                <span className="font-medium text-gray-200">{category.label}</span>
                <FaPlus 
                  className={`w-4 h-4 transition-transform ${
                    expandedSections.includes(category.category) ? 'rotate-45' : ''
                  }`} 
                />
              </button>
              
              {expandedSections.includes(category.category) && (
                <div className="border-t border-gray-700 bg-gray-800">
                  {category.sections.map((section) => {
                    const IconComponent = section.icon;
                    return (
                      <button
                        key={section.type}
                        onClick={() => handleAddSection(section.type)}
                        className="w-full flex items-center px-6 py-3 text-left hover:bg-gray-700 transition-colors text-sm text-gray-300"
                      >
                        <IconComponent className="w-4 h-4 ml-3 text-blue-400" />
                        {section.label}
                      </button>
                    );
                  })}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>

      {/* Quick Actions */}
      <div className="p-4 border-t border-gray-700">
        <h3 className="text-lg font-semibold mb-4 text-gray-200">
          {isRTL ? 'إجراءات سريعة' : 'Quick Actions'}
        </h3>
        
        <div className="space-y-2">
          <button className="w-full flex items-center px-4 py-2 bg-blue-600 hover:bg-blue-700 rounded-lg transition-colors">
            <FaPlus className="w-4 h-4 ml-3" />
            {isRTL ? 'إضافة صفحة جديدة' : 'Add New Page'}
          </button>
          
          <button className="w-full flex items-center px-4 py-2 bg-green-600 hover:bg-green-700 rounded-lg transition-colors">
            <FaEye className="w-4 h-4 ml-3" />
            {isRTL ? 'معاينة الموقع' : 'Preview Site'}
          </button>
          
          <button className="w-full flex items-center px-4 py-2 bg-purple-600 hover:bg-purple-700 rounded-lg transition-colors">
            <FaCog className="w-4 h-4 ml-3" />
            {isRTL ? 'إعدادات متقدمة' : 'Advanced Settings'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AdminSidebar; 